import { useContext } from "react";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import ResumenLista from "_+_Portal/_-_Autocheckin/components/genericos/ResumenLista/ResumenLista";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";

import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";

import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  createListaResumen,
  createRuta,
  msjPaciente,
  proximoPaso,
} from "../PagesFun";
import {
  ResumenBotones,
  ResumenContainer,
  ResumenMensajes,
} from "./LocalStyle";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";

const Resumen = ({ turnoActual }) => {
  // -------------------------  context ----------------------------
  const {
    turnosSeleccionadosState,
    pasoDispatch,
    rutaDispatch,
    textosAutoCheckinState,
    puntoControlDispatch,
  } = useContext(AutocheckContext);

  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------
  let idTerminal = getLocalStorage("idTerminal");

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];

  const turno = listTurnosSeleccionado[turnoActual];

  const medico = turno?.medico;
  const especialidad = turno?.especialidad;

  const irPuntoControl = (e) => {
    setIdTipoPuntoControl(e?.id, e?.mensaje)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };
  const ResubirOrden = () => {
    setPaso("SubirOrden")(pasoDispatch);
  };
  const listaResumen = createListaResumen(
    {
      ...turno?.resumen,
      flgSoloConsulta: turno?.flgSoloConsulta,
      flgSoloPractica: turno?.flgSoloPractica,
      requiereAutorizacion: turno?.requiereAutorizacion,
      flgSaldada: turno?.flgSaldada,
      cobertura: turno?.cobertura,
    },
    ResubirOrden,
    irPuntoControl,
  );

  const mensajeStr =
    "El turno cuenta con lo necesario para hacer la validación con tu cobertura y terminar la recepción";
  let msj = msjPaciente(listaResumen);
  msj =
    msj === 2
      ? textosAutoCheckinState.textosAutoCheckin?.data?.estadoTurnoBien?.nombre
      : msj === 1
        ? textosAutoCheckinState.textosAutoCheckin?.data?.estadoTurnoRegular
            ?.nombre
        : textosAutoCheckinState.textosAutoCheckin?.data?.estadoTurnoMal
            ?.nombre;

  // -------------------------  constantes ----------------------------

  // -------------------------  useEffects  ----------------------------

  //  -------------------------  useEffects  ----------------------------

  // -------------------------  funciones  ----------------------------
  const handleContinuar = () => {
    const ruta = createRuta(listaResumen);
    console.log("[FLUJO] Resumen.handleContinuar - listaResumen:", listaResumen.map(i => ({path: i.path, estado: i.estado, id: i.id})));
    console.log("[FLUJO] Resumen.handleContinuar - ruta antes del shift:", [...ruta]);
    setRuta(proximoPaso(ruta, setPaso, pasoDispatch))(rutaDispatch);
    console.log("[FLUJO] Resumen.handleContinuar - ruta despues del shift:", ruta);
  };
  // -------------------------  funciones ----------------------------

  return (
    <LayoutPasos
      volverTo={"/autocheckin"}
      handleClick={() => {
        setPaso("NumeroAfiliado")(pasoDispatch);
      }}
      type={"no-circle"}
      title={"AUTO CHECK IN"}
    >
      <CardBlueHeart
        medico={medico ? medico : especialidad}
        turnoTitle={especialidad}
        pasoActual={turnoActual + 1}
        pasoTotal={listTurnosSeleccionado.length}
      />
      <ResumenContainer
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <ResumenMensajes>
          <span
            className={`resumenmensajes-titulo ${idTerminal ? "rb32b" : "rb24b"}`}
            dangerouslySetInnerHTML={{ __html: msj }}
          />
          <span
            className={`resumenmensajes-mensaje ${idTerminal ? "rb24m" : "rb18m"}`}
          >
            {mensajeStr}
          </span>
        </ResumenMensajes>
        <ResumenLista lista={listaResumen} />
        <ResumenBotones>
          <button className="btn bgc-primary c-white" onClick={handleContinuar}>
            <span className="rb18m">Continuar</span>
          </button>
        </ResumenBotones>
      </ResumenContainer>
    </LayoutPasos>
  );
};

export default Resumen;
